import React from 'react'
import { Col, Input } from 'reactstrap'

export default function SelectDropdown({
  header, 
  name, 
  value, 
  selectOption,  
  disabled, 
  children,
}) {
  return (
    <Col>
      <h4 className='title'>{header}</h4>
      <Input
        type='select'
        name={name}
        value={value}
        onChange={(e) => selectOption(e)}
        disabled={disabled}
      >
        {children}
      </Input>
    </Col>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/Licenses/SelectDropdown.js